import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const StatutoryAudits = () => {
  const serviceData = {
    title: "Statutory, Tax & Internal Audits",
    heading: "Statutory, Tax & Internal Audits",
    image: subTopicImages["Statutory, Tax & Internal Audits"],
    intro:
      "Ensuring transparency, reliability and compliance in financial reporting",
    description: [
      "Statutory and tax audits are key regulatory requirements under Indian law. These audits ensure that financial statements present a true and fair view and that companies comply with applicable accounting standards and tax laws.",
      "Our statutory audit methodology combines risk-based testing, industry knowledge and structured documentation. This enables us to deliver high-quality independent assurance while also identifying opportunities for process and control improvement.",
    ],
    services: [
      {
        title: "Financial Statement Audits",
        text: "Independent examination of financial statements under:",
        list: [
          "Companies Act",
          "Accounting Standards / Ind-AS",
          "Trust & LLP statutory laws",
        ],
        extraInfo:
          "To ensure accuracy, disclosure compliance and fair presentation.",
      },
      {
        title: "Tax & Regulatory Audits",
        text: "Audit services under Income-tax and other tax regulations including:",
        list: [
          "Tax audit",
          "Certification & reporting requirements",
          "Compliance examinations",
        ],
        extraInfo:
          "Ensuring adherence to statutory tax rules and regulatory requirements.",
      },
      {
        title: "Internal Audits",
        text: "Independent review of internal systems, controls and financial discipline to:",
        list: ["strengthen governance", "detect risks early"],
        extraInfo:
          "Helping organisations enhance operational efficiency and risk management.",
      },
    ],
    benefitsIntro: "Benefits of this service:",
    benefits: [
      "Full statutory compliance",
      "Enhanced stakeholder confidence",
      "Transparent financial reporting",
      "Independent & objective audit approach",
      "Stronger risk and control oversight",
    ],
    research:
      "Our audit team brings together deep technical knowledge and practical commercial understanding — delivering reliable assurance that supports Board, investor and regulator confidence.",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      projects={serviceData.benefits}
    />
  );
};

export default StatutoryAudits;
